/* eslint-disable no-unneeded-ternary */
/* eslint-disable react/prop-types */
import { Box, Button, Grid, TextField, Typography } from '@material-ui/core';
import React, { useState } from 'react';
import { Autocomplete } from '@material-ui/lab';
// eslint-disable-next-line import/extensions
import filterStyles from '../filterStyles';
import useApp from '../../hooks/useApp';

const DuplicateLeadsReportFilter = ({ filters, setFilters, handleClearFilters = () => {} }) => {
  const { partners, brokers } = useApp();

  const [currentFilters, setCurrentFilters] = useState({
    partner: '',
    client_name: '',
    proposal_id: '',
    period_start: '',
    period_end: '',
  });

  const classes = filterStyles();

  const handleChange = (e) => {
    e.preventDefault();

    const { name, value } = e.target;

    setCurrentFilters({
      ...currentFilters,
      [name]: value,
    });
  };

  const handleClear = () => {
    setCurrentFilters({
      partner: '',
      client_name: '',
      proposal_id: '',
      period_start: '',
      period_end: '',
    });

    handleClearFilters();
  };

  const handleFilter = () => {
    setFilters({
      ...filters,
      ...currentFilters,
      partner_id: currentFilters.partner?.id || '',
    });
  };

  return (
    <Box className={classes.boxFilter}>
      <Grid container spacing={2} alignItems="center">
        <Grid container item xs={12} md={12} alignItems="center" spacing={2}>
          <Grid container item spacing={2} alignItems="flex-end">
            <Grid
              item
              style={{
                display: 'flex',
                flexDirection: 'column',
                gap: '4px',
                color: 'GrayText',
              }}>
              <Typography>Data de criação inicial: </Typography>
              <TextField
                className={classes.inputDate}
                type="date"
                name="period_start"
                placeholder="Data Inicial"
                value={currentFilters.period_start}
                onChange={handleChange}
              />
            </Grid>
            <Grid
              item
              style={{
                display: 'flex',
                flexDirection: 'column',
                gap: '4px',
                color: 'GrayText',
              }}>
              <Typography>Data de criação final: </Typography>
              <TextField
                className={classes.inputDate}
                type="date"
                name="period_end"
                placeholder="Data Inicial"
                value={currentFilters.period_end}
                onChange={handleChange}
              />
            </Grid>
            <Grid item>
              <TextField
                className={classes.inputSelect}
                variant="standard"
                placeholder="Proposta"
                name="proposal_id"
                value={currentFilters.proposal_id}
                onChange={handleChange}
              />
            </Grid>
            <Grid item>
              <TextField
                className={classes.inputSelect}
                variant="standard"
                placeholder="Cliente"
                name="client_name"
                value={currentFilters.client_name}
                onChange={handleChange}
              />
            </Grid>
            <Grid item xs={12} md={3}>
              <Autocomplete
                value={currentFilters.partner}
                options={partners ? partners : []}
                getOptionLabel={(option) => option?.name}
                onChange={(e, value) =>
                  setCurrentFilters({
                    ...currentFilters,
                    partner: value,
                  })
                }
                className={classes.inputSelect}
                renderInput={(params) => <TextField {...params} variant="standard" placeholder="Concessionária" />}
              />
            </Grid>

            <Grid item>
              <Button fullWidth className={classes.button} onClick={handleClear}>
                Limpar
              </Button>
            </Grid>

            <Grid item>
              <Button fullWidth className={classes.button} onClick={handleFilter}>
                Filtrar
              </Button>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </Box>
  );
};

export default DuplicateLeadsReportFilter;
